import React from 'react'
import ReactDOM from 'react-dom';
import cookies from '../../services/cookies';

//Redux saga
import { select, takeEvery, put } from 'redux-saga/effects';

//Actions
import * as actions from '../actions/locales';

//Action types
import * as actionTypes from '../actions/locales/actionTypes';

//Components
import Notification from '../../components/Notifications/Notifications';

//Utils
import axios from '../../services/axios-client';
import i18n from '../../translations/i18n';
import moment from 'moment'
import 'moment/min/locales.min';

export function* loadLocale() {
    const locale = yield select(state => state.widget.locale)

    yield i18n.changeLanguage(locale);
    axios.defaults.headers.common['locale'] = locale;
    moment.locale(locale);
    const __months = moment.months().map(function (m) {
        return m.charAt(0).toUpperCase() + m.slice(1);
    });
    moment.updateLocale(locale, { months: __months });

    yield put(actions.loadLocaleSucceeded(locale));
}

export function* getLocales() {
    try {
        const resp = yield axios.request({
            method: 'GET',
            url: '/api/app/localization/list'
        });
        const { data: { result } } = resp;

        yield put(actions.getLocalesSucceeded(result));
    } catch (error) {
        ReactDOM.render(
            <Notification type='error' error={error} />,
            document.getElementById('notification')
        );
    }
}

export function* changeLanguage({ locale }) {
    const strictPath = yield select(state => state.widget.strictPath);

    yield i18n.changeLanguage(locale);
    axios.defaults.headers.common['locale'] = locale;
    moment.locale(locale);
    const __months = moment.months().map(function (m) {
        return m.charAt(0).toUpperCase() + m.slice(1);
    });
    moment.updateLocale(locale, { months: __months });

    cookies.set('locale', locale, {
        path: strictPath ? window.location.pathname : '/',
        domain: window.location.hostname,
        secure: true,
        sameSite: true,
    });

    yield put(actions.changeLanguageSucceeded(locale));
}

export const watchLocales = [
    takeEvery(actionTypes.LOAD_LOCALE, loadLocale),
    takeEvery(actionTypes.GET_LOCALES, getLocales),
    takeEvery(actionTypes.CHANGE_LOCALE, changeLanguage)
];